__turbopack_context__.v({
  "header--search": "Lg4wHG_header--search",
  "searchBar--searchPage": "Lg4wHG_searchBar--searchPage",
  "searchBar__form": "Lg4wHG_searchBar__form",
  "searchBar__icon": "Lg4wHG_searchBar__icon",
  "searchBar__input": "Lg4wHG_searchBar__input",
});
